import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MaterialAppModule } from "../ngmaterial.module";
import { MatSnackBarConfig } from "@angular/material";

import { GenericTableComponent, GenericTableService } from ".";
import { CommonModule } from "../common/common.module";
import { DeviceTypeColumnComponent } from "./deviceType-column/deviceType-column.component";
import { CustomComponentColumnComponent } from "./customComponent-column/customComponent-column.component";

@NgModule({
	imports: [
		FormsModule,
		ReactiveFormsModule,
		BrowserAnimationsModule,
		FlexLayoutModule,
		BrowserModule,
		CommonModule,
		MaterialAppModule
	],
	declarations: [
		GenericTableComponent,
		DeviceTypeColumnComponent,
		CustomComponentColumnComponent
	],
	entryComponents: [
	],
	providers: [
		MatSnackBarConfig,
		GenericTableService
	],
	exports: [
		GenericTableComponent
	]
})
export class GenericTableModule { }
